import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import EmailAccountsModal from '../components/EmailAccountsModal';
import { useEmail } from '../contexts/EmailContext';

const SettingsPage = () => {
  const navigate = useNavigate();
  const { accounts, activeAccountId } = useEmail();
  const [showEmailAccountsModal, setShowEmailAccountsModal] = useState(false);

  return (
    <div className="max-w-3xl mx-auto p-4 sm:p-8">
      <button
        onClick={() => navigate('/app')}
        className="mb-6 flex items-center gap-2 text-sm text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-200 transition-colors"
      >
        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M15 19l-7-7 7-7" />
        </svg>
        Back to Dashboard
      </button>

      <h1 className="text-2xl font-bold text-gray-900 dark:text-white mb-8">Settings</h1>

      {/* Email Accounts Section */}
      <div className="bg-white dark:bg-[#1A1A1A] border border-gray-200 dark:border-[#2A2A2A] rounded-2xl p-6 mb-6">
        <div className="flex items-center justify-between mb-4">
          <div>
            <h2 className="text-lg font-semibold text-gray-900 dark:text-white">Email Accounts</h2>
            <p className="text-sm text-gray-500 dark:text-gray-400 mt-1">
              Connect email accounts to send invoices and communicate with clients.
            </p>
          </div>
          <button
            onClick={() => setShowEmailAccountsModal(true)}
            className="bg-brand hover:bg-brand-hover text-white px-4 py-2 rounded-xl text-sm font-medium transition-colors"
          >
            Manage
          </button>
        </div>

        {accounts.length === 0 ? (
          <div className="bg-amber-50 dark:bg-amber-900/20 border border-amber-200 dark:border-amber-700 rounded-xl p-4">
            <p className="text-sm text-amber-700 dark:text-amber-300">
              No email accounts connected. Connect an account to send invoices via email.
            </p>
          </div>
        ) : (
          <div className="space-y-3">
            {accounts.map((account) => (
              <div
                key={account.accountId}
                className={`flex items-center justify-between p-3 rounded-xl border ${
                  account.accountId === activeAccountId
                    ? 'border-brand bg-orange-50 dark:bg-orange-900/10'
                    : 'border-gray-200 dark:border-[#2A2A2A]'
                }`}
              >
                <div className="flex items-center gap-3">
                  <div className="w-8 h-8 bg-gray-100 dark:bg-[#2A2A2A] rounded-full flex items-center justify-center">
                    <svg className="w-4 h-4 text-gray-500 dark:text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                    </svg>
                  </div>
                  <div>
                    <p className="text-sm font-medium text-gray-900 dark:text-white">{account.email}</p>
                    {account.accountId === activeAccountId && (
                      <p className="text-xs text-brand">Active</p>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      <EmailAccountsModal
        isOpen={showEmailAccountsModal}
        onClose={() => setShowEmailAccountsModal(false)}
      />
    </div>
  );
};

export default SettingsPage;
